import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';
import { CertificateResponseData } from 'src/common/interfaces/certificate';
import { apiSlice } from 'src/features/api/api-slice';

import { CertificateData } from './certificate.type';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExistingCertificate: builder.query<ApiResponse<CertificateResponseData>, CertificateData>({
      query: ({ code, type }: CertificateData) => ({
        url: `certificates`,
        method: 'GET',
        params: { name: code, type, createIfNotExists: false },
      }),
      providesTags: [RTKQueryTag.GetCertificate],
    }),
    createCertificate: builder.mutation<ApiResponse<CertificateResponseData>, CertificateData>({
      query: ({ code, type }: CertificateData) => ({
        url: `certificates`,
        method: 'GET',
        params: { name: code, type, createIfNotExists: true },
      }),
      invalidatesTags: [RTKQueryTag.GetCertificate],
    }),
  }),
});

export const { useGetExistingCertificateQuery, useCreateCertificateMutation } = extendedApiSlice;
